import {
  TesEmployeesListingGetters,
  TesEmployeesListingMutations,
  TesEmployeesListingActions
} from '@/app/features/tes-employees/features/tes-employees-listing/tes-employees-listing.keys';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import { tesEmployeesListingService as tesEmployeesService } from '@/app/features/tes-employees/features/tes-employees-listing/tes-employees-listing.service';
import i18n from '@/i18n';

export const getInitialState = () => {
  return {
    tesEmployeesLoading: true,
    tesEmployees: [],
    searchParam: '',
    tesEmployeesRecordCount: 0,
    tesEmployeesSortOrder: {
      sortBy: 'tesEmployeeName',
      sortDirection: 'asc'
    },
    tesEmployeesPaginationParameters: {
      recordsPerPage: 10,
      offset: 0
    },
    tesEmployeesActiveInactive: 'both'
  };
};

export const tesEmployeesListingStore = {
  state: getInitialState(),
  getters: {
    [TesEmployeesListingGetters.TesEmployeesList]: state => state.tesEmployees,
    [TesEmployeesListingGetters.SortBy]: state => state.tesEmployeesSortOrder.sortBy,
    [TesEmployeesListingGetters.SortDirection]: state => state.tesEmployeesSortOrder.sortDirection,
    [TesEmployeesListingGetters.TesEmployeesPerPage]: state =>
      state.tesEmployeesPaginationParameters.recordsPerPage,
    [TesEmployeesListingGetters.TesEmployeesListingOffset]: state =>
      state.tesEmployeesPaginationParameters.offset,
    [TesEmployeesListingGetters.TesEmployeesRecordCount]: state => state.tesEmployeesRecordCount,
    [TesEmployeesListingGetters.TesEmployeesActiveInactive]: state =>
      state.tesEmployeesActiveInactive
  },
  mutations: {
    [TesEmployeesListingMutations.SetTesEmployeesLoading](state, isLoading = true) {
      state.tesEmployeesLoading = isLoading;
    },

    [TesEmployeesListingMutations.SetTesEmployeesList](state, tesEmployees) {
      state.tesEmployees = tesEmployees;
    },
    [TesEmployeesListingMutations.SetTesEmployeesSortOrder](state, sortOrder) {
      state.tesEmployeesSortOrder = sortOrder;
    },
    [TesEmployeesListingMutations.SetTesEmployeesPaginationParameters](state, pagination) {
      state.tesEmployeesPaginationParameters = pagination;
    },
    [TesEmployeesListingMutations.ResetTesEmployeesPaginationOffset](state) {
      state.tesEmployeesPaginationParameters.offset = 0;
    },
    [TesEmployeesListingMutations.SetTesEmployeesRecordCount](state, recordCount) {
      state.tesEmployeesRecordCount = recordCount;
    },
    [TesEmployeesListingMutations.SetTesEmployeesActiveInactive](state, activeInactive) {
      state.tesEmployeesActiveInactive = activeInactive;
    },
    [TesEmployeesListingMutations.SetSearchParam](state, searchParam) {
      state.searchParam = searchParam;
    }
  },
  actions: {
    [TesEmployeesListingActions.RetrieveTesEmployees]({ state, commit, dispatch }) {
      commit(TesEmployeesListingMutations.SetTesEmployeesLoading);

      return tesEmployeesService
        .retrieveTesEmployees(
          state.tesEmployeesActiveInactive,
          state.tesEmployeesSortOrder,
          state.tesEmployeesPaginationParameters,
          state.searchParam
        )
        .then(tesEmployees => {
          tesEmployees.map(tesEmployee => {
            tesEmployee.tesEmployeeName = tesEmployee.last_name + ', ' + tesEmployee.first_name;
          });
          dispatch(TesEmployeesListingActions.RetrieveTesEmployeesRecordCount);
          commit(TesEmployeesListingMutations.SetTesEmployeesList, tesEmployees);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('tesEmployees.listing.errors.retrieveTesEmployees')
          });
          commit(TesEmployeesListingMutations.SetTesEmployeesLoading, false);
        });
    },
    [TesEmployeesListingActions.SetTesEmployeesSortOrder]({ commit, dispatch }, sortOrder) {
      commit(TesEmployeesListingMutations.SetTesEmployeesSortOrder, sortOrder);
      commit(TesEmployeesListingMutations.ResetTesEmployeesPaginationOffset);
      dispatch(TesEmployeesListingActions.RetrieveTesEmployees);
    },
    [TesEmployeesListingActions.SetTesEmployeesPaginationParameters](
      { commit, dispatch },
      pagination
    ) {
      commit(TesEmployeesListingMutations.SetTesEmployeesPaginationParameters, pagination);
      dispatch(TesEmployeesListingActions.RetrieveTesEmployees);
    },
    [TesEmployeesListingActions.SetTesEmployeesActiveInactive](
      { commit, dispatch },
      activeInactive
    ) {
      commit(TesEmployeesListingMutations.SetTesEmployeesActiveInactive, activeInactive);
      dispatch(TesEmployeesListingActions.RetrieveTesEmployees);
    },

    [TesEmployeesListingActions.ExportCurrentPageTesEmployeesAsExcel]: function({ state }) {
      return tesEmployeesService.downloadCurrentTesEmployeesXlsx(
        state.tesEmployeesActiveInactive,
        state.tesEmployeesSortOrder,
        state.tesEmployeesPaginationParameters,
        state.searchParam
      );
    },

    [TesEmployeesListingActions.ExportAllTesEmployeesAsExcel]: function({ state }) {
      return tesEmployeesService.downloadAllTesEmployeesXlsx(
        state.tesEmployeesActiveInactive,
        state.tesEmployeesSortOrder,
        state.searchParam
      );
    },

    [TesEmployeesListingActions.UpdateSearchList]: function({ commit, dispatch }, searchList) {
      commit(TesEmployeesListingMutations.SetSearchParam, searchList.searchParam);
      commit(TesEmployeesListingMutations.ResetTesEmployeesPaginationOffset);
      return dispatch(TesEmployeesListingActions.RetrieveTesEmployeesRecordCount).then(() => {
        commit(TesEmployeesListingMutations.SetTesEmployeesList, searchList.data);
      });
    },

    [TesEmployeesListingActions.RetrieveTesEmployeesRecordCount]: ({ state, commit, dispatch }) => {
      return tesEmployeesService
        .retrieveRecordCount(state.tesEmployeesActiveInactive, state.searchParam)
        .then(res => {
          commit(TesEmployeesListingMutations.SetTesEmployeesRecordCount, res);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error
          });
        });
    }
  }
};
